import { PolarisVizProvider } from '@shopify/polaris-viz';
import { useTheme } from 'next-themes';
import * as React from 'react';

import '@shopify/polaris-viz/build/esm/styles.css';
import { ENGAGE_THEME_DARK, ENGAGE_THEME_LIGHT, engageDarkTheme, engageLightTheme } from './theme';

const THEMES = { [ENGAGE_THEME_LIGHT]: engageLightTheme, [ENGAGE_THEME_DARK]: engageDarkTheme };

// Wraps the app so every Polaris Viz chart inherits our branded theme, switching
// the light/dark variant with the app theme.
export function ChartProvider({ children }: { children: React.ReactNode }): React.JSX.Element {
  const { resolvedTheme } = useTheme();
  const defaultTheme = resolvedTheme === 'dark' ? ENGAGE_THEME_DARK : ENGAGE_THEME_LIGHT;
  return (
    <PolarisVizProvider themes={THEMES} defaultTheme={defaultTheme}>
      {children}
    </PolarisVizProvider>
  );
}
